<template>
  <div
    class='doo3d-right-container'
    @contextmenu.prevent="openMenu($event,item)"
  >

    <div class="wrap_loading">
      <div class="loading">
        <div class="l1"></div>
        <div class="l2"></div>
        <div class="l3"></div>
        <div class="l4"></div>
      </div>
    </div>
    <div
      id='doo3d'
      class='fixed-size'
    />
  </div>
</template>

<script>
import doo3d from "../doo3d";
import $ from "jquery";

export default {
  name: "doo3d",
  props: {
    opts: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    opts: {
      handler(n) {
        doo3d.init(this.opts.id, () => {
          $(".wrap_loading").hide();
        });
      },
      deep: true,
    },
  },
  mounted() {},
  unmounted() {
    doo3d.shutdown();
  },
  methods: {
    openMenu(e) {
    },
  },
};
</script>

<style scoped>
.doo3d-right-container {
  position: absolute;
  width: 54%;
  left: 45%;
  height: 840px;
  box-sizing: border-box;
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 20px;
  border: 1px solid #dcdfe6;
  padding: 4px;
}

#doo3d {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: black;
}

.wrap_loading {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #00000077;
  z-index: 99999;
}

.loading {
  width: 50px;
  height: 60px;
  text-align: center;
  font-size: 10px;
  position: relative;
  left: 50%;
  top: 50%;
  margin-top: -30px;
  margin-left: -25px;
}

.loading > div {
  background-color: #fff;
  height: 50px;
  width: 6px;
  display: inline-block;
  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.loading .l1 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
  margin-left: 2px;
}

.loading .l2 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
  margin-left: 2px;
}

.loading .l3 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
  margin-left: 2px;
}

.loading .l4 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
  margin-left: 2px;
}

@-webkit-keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
  }
}

@keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}
</style>
